import {
    StyledNumber,
    StyledPointContainer,
    StyledTextContainer
} from '../styles'
import { Text } from '../../../../../common/typography'
import { colors } from 'shared/assets/styles'
import { fonts } from '../../../../../../app-v2/design-systems'
import React from 'react'

export const ListItem = ({
    number,
    text
}: {
    number: number,
    text: string
}) => {
    return (
        <StyledPointContainer>
            <StyledNumber>
                <Text color={colors.white} font={fonts.flameRegular}>
                    {number}
                </Text>
            </StyledNumber>
            <StyledTextContainer>
                <Text font={fonts.flameSansRegular}>{text}</Text>
            </StyledTextContainer>
        </StyledPointContainer>
    )
}
